import { graphql, Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React, { ReactNode, useState } from "react";
import Navigation from "./Navigation";
import PageTitle from "./PageTitle";
import SocialLinks from "./SocialLinks";

type HeaderProps = {
  settings: Queries.SiteSettingsFragment | null;
  nav: Queries.SiteSettingsFragment["navigationItems"];
};

const Header = (props: HeaderProps) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <>
      <div>
        <div className="bg-c-header">
          <div className="container mx-auto px-5 py-5 flex flex-col xl:flex-row xl:justify-between xl:relative items-center xl:items-start">
            <div className="bg-white flex justify-center items-center w-52 h-52 rounded-full xl:absolute z-50">
              <Link to="/">
                <StaticImage
                  alt="Somewhere In Sandviken"
                  className=""
                  placeholder="blurred"
                  src="../../images/somewhereinsandviken-logo.png"
                />
              </Link>
            </div>
            <div className="xl:basis-1/6"></div>
            <div className="xl:basis-4/6 mt-4 xl:mt-0">
              <PageTitle
                title={props.settings?.siteTitle ?? ""}
                className="text-3xl text-white"
              />
            </div>
            <div className="hidden xl:basis-1/6 self-center xl:flex justify-end">
              <SocialLinks />
            </div>
          </div>
        </div>
        <div className="bg-c-subnav text-white xl:pl-0">
          <div className="container mx-auto px-5 pt-5 pb-2 flex flex-col lx:flex-row justify-center">
            <div
              className="xl:hidden mb-2 flex flex-col items-center gap-y-2"
              onClick={() => {
                if (menuOpen) setMenuOpen(false);
                else setMenuOpen(true);
              }}
            >
              <div className="w-[30px] h-[4px] bg-white"></div>
              <div className="w-[30px] h-[4px] bg-white"></div>
              <div className="w-[30px] h-[4px] bg-white"></div>
            </div>
            <Navigation open={menuOpen} placement="Header" src={props.nav} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
